import { useState } from 'react';
import PageTransition from '@/components/ui/PageTransition';
import { PageHeader } from '@/components/ui/PageHeader';
import { TabbedCountCard } from '@/components/shared/TabbedCountCard';
import {
  SolutionOutlined,
  TeamOutlined
} from '@ant-design/icons';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import {
  useJobModuleJobsQuery,
  useJobModuleApplicationsQuery,
  APPLICATIONS_LARGE_LIMIT
} from '../api';
import { createModuleRouteGuard } from '@/modules/routeGuards';
import { JobsTable } from '../components/JobsTable';
import { ApplicationsTable } from '../components/ApplicationsTable';

// File-based route definition using virtual file routes
// Note: Must use string literal for createFileRoute (build-time requirement)
// MODULE_BASE_ROUTE is still used for Links and other runtime uses
export const Route = createFileRoute('/manage/modules/jobModule/')({
  component: JobModulePage,
  beforeLoad: createModuleRouteGuard('job-module')
});

export function JobModulePage() {
  const { t } = useTranslation('job-module');
  const [activeTab, setActiveTab] = useState('applications');

  // Queries for badge counts - using same large limit as ApplicationsTable for cache sharing
  const { data: jobsData } = useJobModuleJobsQuery();
  const { data: applicationsData } = useJobModuleApplicationsQuery({
    limit: APPLICATIONS_LARGE_LIMIT,
    offset: 0
  });

  return (
    <PageTransition animation="fadeInUp">
      <PageHeader icon={<SolutionOutlined />} title={t('pageTitle')} description={t('pageDescription')} />

      <TabbedCountCard
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: 'applications',
            icon: <TeamOutlined />,
            label: t('tabs.applications'),
            count: applicationsData?.count || 0,
            children: <ApplicationsTable />
          },
          {
            key: 'jobs',
            icon: <SolutionOutlined />,
            label: t('tabs.jobs'),
            count: jobsData?.jobs?.length || 0,
            children: <JobsTable />
          }
        ]}
      />
    </PageTransition>
  );
}
